// Vue
import { defineComponent } from "vue";

// Providers
import useModalConfirm from "./providers/ModalConfirm";

// Components
import Modal from "@/components/Reusables/Modal/Modal.vue";
import Button from "@/components/Reusables/Buttons/Button.vue";

const ModalConfirmComponent = defineComponent({
    props: {
        heading: {
            type: String,
            required: true,
        },
        message: {
            type: String,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
        onConfirm: {
            type: Function,
            required: true,
        },
    },
    setup(props) {
        // ///////////////////
        // Providers
        // ///////////////////

        const confirmModal = useModalConfirm();

        // ///////////////////
        // Computed
        // ///////////////////

        // ///////////////////
        // Return
        // ///////////////////

        return {
            props,
            confirmModal,
        };
    },
    render() {
        const { props, confirmModal } = this;

        return (
            <Modal
                {...{
                    show: () => confirmModal.showModalConfirm(props.id),
                    size: "w-2/6 h-fit",
                    heading: props.heading,
                    toggleModal: () => confirmModal.toggleModalConfirm(props.id),
                }}>
                <div class="flex flex-col space-y-px-24">
                    <span class="text-type-default">{props.message}</span>
                    <div class="flex justify-between">
                        <Button
                            {...{
                                label: "Cancel",
                                color: "button",
                                onClick() {
                                    confirmModal.toggleModalConfirm(props.id);
                                },
                            }}
                        />
                        <Button
                            {...{
                                label: "Confirm",
                                color: "destructive",
                                async onClick() {
                                    // Confirm for consume
                                    confirmModal.confirm(props.id);

                                    // Call the confirm function
                                    await props.onConfirm();
                                },
                            }}
                        />
                    </div>
                </div>
            </Modal>
        );
    },
});

export default ModalConfirmComponent;
